import type { ExternalStockStatus } from 'types/capi/shared';

export type StockStatus =
  | 'in-stock'
  | 'tbc'
  | 'reseller'
  | 'upcoming'
  | 'coming-soon'
  | 'sold-out';

export const textColours = {
  'coming-soon': 'text-purple-hola',
  'in-stock': 'text-forest',
  reseller: 'text-reseller-blue',
  'sold-out': 'text-red-alert',
  tbc: 'text-purple-hola',
  upcoming: 'text-purple-hola'
};

export const borderColours = {
  'coming-soon': 'border-purple-hola',
  'in-stock': 'border-forest',
  reseller: 'border-reseller-blue',
  'sold-out': 'border-red-alert',
  tbc: 'border-purple-hola',
  upcoming: 'border-purple-hola'
};

export function getStockStatus(
  externStockStatus: ExternalStockStatus
): StockStatus | undefined {
  switch (externStockStatus) {
    case 'IN_STOCK':
    case 'in-stock':
      return 'in-stock';

    case 'SOLD_OUT':
    case 'sold-out':
      return 'sold-out';

    case 'RESELLER':
    case 'reseller':
      return 'reseller';

    case 'COMING_SOON':
    case 'coming-soon':
      return 'coming-soon';

    case 'upcoming':
    case 'UPCOMING':
      return 'upcoming';

    case 'tbc':
    case 'TBC':
      return 'tbc';
  }
}
